export default __webpack_public_path__ + "static/media/view4_year_place_cause_.b76af94c.csv";